import { render } from "./PayUnlockShell.vue?vue&type=template&id=204bc989&scoped=true"
import script from "./PayUnlockShell.vue?vue&type=script&lang=js"
export * from "./PayUnlockShell.vue?vue&type=script&lang=js"

import "./PayUnlockShell.vue?vue&type=style&index=0&id=204bc989&scoped=true&lang=less"
import "./PayUnlockShell.vue?vue&type=style&index=1&id=204bc989&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204bc989"]])

export default __exports__